import { concatMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Store } from '@ngxs/store';

import { KeyOf } from '@shared/utilities/typescript.utilities';

export function assertStoreData<T>(
  store: Store,
  selector: (...args: any[]) => T,
  action: any,
  checker: ((data: T) => boolean) | KeyOf<T> = (data: T): boolean => data != null,
  actualSelector: (...args: any[]) => T = selector,
): Observable<T> {
  const checkData = typeof checker === 'string' ? (data: T) => !!data[checker] : checker;
  const hasData = checkData(store.selectSnapshot<T>(selector));

  return (hasData ? of(void 0) : store.dispatch(action)).pipe(concatMap(() => store.select<T>(actualSelector)));
}
